"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "initWordPress", {
  enumerable: true,
  get: function get() {
    return _initWordPress.default;
  }
});
exports.isWordPress = void 0;

var _initWordPress = _interopRequireDefault(require("./initWordPress"));

var _checkIfWordPress = _interopRequireDefault(require("./checkIfWordPress"));

var isWordPress = (0, _checkIfWordPress.default)();
exports.isWordPress = isWordPress;